<template>
  <a-card :bordered="false" title="店员设置">
    <a-form layout="inline">
      <a-form-item label="姓名/手机号">
        <a-input v-model="queryParams.saffContactName" placeholder="姓名/手机号"></a-input>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
        <a-button @click="addclerk">添加店员</a-button>
      </a-form-item>
    </a-form>
    <custom-page-table
      style="margin-top:16px;"
      ref="table"
      :queryParams="queryParams"
      :columns="columns"
      base-key="userUrl"
      params-path="user/merchantStore/queryMerchantStoreMembersList"
    >
      <span slot="action" slot-scope="rowItem">
        <a-popconfirm
          :title="isRole?'本店已存在店长账号，继续操作将撤销原店长账号权限,是否继续?':'此操作将该店员设为店长, 是否继续?'"
          @confirm="actionRole(rowItem.record.storeMembersId,rowItem.record.role)" v-if="rowItem.record.role == 1">
          <a style="display: inline-block;margin-right: 20px">设为店长</a>
        </a-popconfirm>
        <a-popconfirm title="此操作撤销店长, 是否继续?"
                      @confirm="actionRole(rowItem.record.storeMembersId,rowItem.record.role)"
                      v-if="rowItem.record.role == 2">
          <a style="display: inline-block;margin-right: 20px">撤销店长</a>
        </a-popconfirm>
        <a-popconfirm title="此操作将移出店员, 是否继续?" @confirm="deleteData(rowItem.record.storeMembersId)">
          <a>移出</a>
        </a-popconfirm>
      </span>
    </custom-page-table>
    <a-modal title="店员账号列表" :width="800" :footer="null" :visible="visible" @cancel="handleCancel">
      <p class="mr15">温馨提示：店员账号仅能从二级分销商中选取并绑定，只能绑定在一个门店中</p>
      <a-form layout="inline">
        <a-form-item label="搜索名称">
          <a-input v-model="queryModel.staffName" placeholder="搜索手机号、真实姓名"></a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="$refs.tableList.refresh(true)">查询</a-button>
        </a-form-item>
      </a-form>
      <custom-page-table
        style="margin-top:16px;"
        ref="tableList"
        :queryParams="queryModel"
        :columns="columnsModel"
        base-key="userUrl"
        params-path="user/merchantStaff/getMerchantStoreMembersStaffList"
      >
        <span slot="index" slot-scope="rowItem">
          {{ rowItem.index + 1 }}
        </span>
        <span slot="action" slot-scope="rowItem">
          <a @click="bandStaffIdData(rowItem.record.staffId)">绑定</a>
        </span>
      </custom-page-table>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'ShopBindAccount',
  data() {
    return {
      queryParams: {
        storeId: this.$route.query.shopId
      },
      queryModel: {},
      columns: [
        {
          title: '店员ID',
          dataIndex: 'storeMembersId'
        },
        {
          title: '姓名',
          dataIndex: 'saffContactName'
        },
        {
          title: '手机号',
          dataIndex: 'saffContactPhone'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      columnsModel: [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '姓名',
          dataIndex: 'staffName'
        },
        {
          title: '手机号',
          dataIndex: 'staffMobile'
        },

        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      merchantId: this.$store.getters.userInfo.merchantId,
      visible: false,
      storeId: this.$route.query.shopId,
      isRole: false
    }
  },
  created() {
  },
  activated() {
    this.queryParams.storeId = this.$route.query.shopId
    this.storeId = this.$route.query.shopId
    this.$refs.table.refresh(true)
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [{ name: 'ShopList', title: '门店管理' }])
    this.getRole()
  },
  methods: {
    addclerk() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.tableList.refresh(true)
      })
    },
    getRole() {
      let parms = { storeId: this.$route.query.shopId }
      this.getHttpServices().getUserService().post('store/existStoreManager', parms).then(res => {
        this.isRole = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    actionRole(storeMembersId, role) {
      let parms = {
        storeMembersId,
        role: role == 1 ? 2 : 1
      }
      this.getHttpServices().getUserService().post('store/updateStoreMemberRole', parms).then(res => {
        this.$message.success('操作成功')
        this.$refs.table.refresh(true)
        this.getRole()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleCancel() {
      this.visible = false
    },
    //移出
    deleteData(mermbersId) {
      this.getHttpServices()
        .getUserService()
        .get(
          'user/merchantStore/deleteMerchantStoreMembers?mermbersId=' + mermbersId + '&merchantId=' + this.merchantId
        )
        .then(res => {
          this.$message.success('店员移出成功')
          this.$refs.table.refresh(true)
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    //绑定二分店员
    bandStaffIdData(staffId) {
      this.getHttpServices()
        .getUserService()
        .post('user/merchantStore/addMerchantStoreMembers', {
          storeId: this.storeId,
          staffId: staffId
        })
        .then(res => {
          this.$message.success('绑定店员成功')
          this.visible = false
          this.$refs.table.refresh(true)
        })
        .catch(err => {
          this.$message.error(err.msg)
          this.visible = false
        })
    }
  }
}
</script>
<style scoped>
.ant-btn + .ant-btn {
  margin-left: 10px;
}

.mr15 {
  margin-right: 15px;
  line-height: 40px;
}
</style>
